import { render, staticRenderFns } from "./AccountSync.vue?vue&type=template&id=cb511d50"
import script from "./AccountSync.vue?vue&type=script&lang=js"
export * from "./AccountSync.vue?vue&type=script&lang=js"
import style0 from "./AccountSync.vue?vue&type=style&index=0&id=cb511d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports